import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "BaseImagePreview" }
const _hoisted_2 = {
  key: 0,
  class: "BaseImagePreview__wrapper column flex-center no-wrap bg-extra-off-white overflow-hidden relative-position rounded-24 shadow-4 fixed-center q-pa-sm"
}
const _hoisted_3 = { class: "column flex-center flex-1 full-width full-height bg-cool-gray-30 rounded-20 overflow-hidden relative-position" }

interface IProps {
  src: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseImagePreview' },
  __name: 'BaseImagePreview',
  props: /*@__PURE__*/_mergeModels({
    src: {}
  }, {
    "modelValue": { type: Boolean, ...{ required: true } },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const model = _useModel<boolean>(__props, "modelValue")

return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      appear: "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }, {
      default: _withCtx(() => [
        (model.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "BaseImagePreview__overlay fixed-full",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (model.value = false), ["self"]))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      appear: "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }, {
      default: _withCtx(() => [
        (model.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", {
                class: "BaseImagePreview__close-btn rounded-circle q-pa-xs bg-white flex inline cursor-pointer absolute",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (model.value = false))
              }, [
                _createVNode(_component_k_icon, {
                  name: "close-rounded",
                  size: "24px",
                  color: "cool-gray-70"
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_q_img, {
                  src: __props.src,
                  width: "100%",
                  height: "100%",
                  fit: "cover",
                  class: "BaseImagePreview__blur absolute-full"
                }, null, 8, ["src"]),
                _createVNode(_component_q_img, {
                  src: __props.src,
                  width: "100%",
                  height: "100%",
                  fit: "contain"
                }, null, 8, ["src"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})